class CustomHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initMenu();
    window.addEventListener("resize", this.initMenu.bind(this));

    this.stickyType = this.dataset.sticky;

    if (this.stickyType !== "none") {
      this.lastScrollTop = 0;
      this.onScrollUp();
      window.addEventListener("scroll", this.onScrollUp.bind(this));
    }else{
      this.ifScrollTop();
      window.addEventListener("scroll", this.ifScrollTop.bind(this));
    }

    this.updateMainMargin();
    this.updateTopPosition();
    window.addEventListener("resize", this.updateTopPosition.bind(this));

    this.themeEditorUpdateUnSubscriber = PubSub.subscribe(PubSub.events.themeEditorUpdate, this.refreshSection.bind(this));
  }

  disconnectedCallback(){
    if(this.themeEditorUpdateUnSubscriber){
        this.themeEditorUpdateUnSubscriber();
    }
  }

  refreshSection(){
    setTimeout(() => {
      this.updateTopPosition();
      this.updateMainMargin();
    }, 100);
  }

  updateTopPosition() {
    const sectionHeaders = Array.from(
      document.querySelectorAll(".section-header:not([data-closed='true'])")
    );

    let topPosition = 0;
    sectionHeaders.some((item) => {
      const headerElement = item.querySelector(".header-element");
      const style = getComputedStyle(headerElement);

      if (headerElement === this) {
        return true;
      } else {
        topPosition =
          topPosition +
          headerElement.offsetHeight +
          parseFloat(style.marginTop) +
          parseFloat(style.marginBottom);
      }
    });

    this.style.transitionDuration = "0s";
    this.style.setProperty("--utility-bar-gap", "0px");
    this.style.setProperty("--announcement-bar-gap", "0px");
    this.style.setProperty("--top", `${topPosition}px`);
    this.style.transitionDuration = "0.3s";
  }

  updateMainMargin(){
    const main = document.querySelector("main");
    if(!main) return;

    const height = this.offsetHeight;
    const style = getComputedStyle(this);
    main.style.setProperty('--header-height', `${height + parseFloat(style.marginTop) + parseFloat(style.marginBottom)}px`);

    if(this.dataset.overlay === 'true'){
      main.style.setProperty('--header-gap', `0px`);
      return;
    }

    main.style.setProperty('--header-gap', `${height + parseFloat(style.marginTop) + parseFloat(style.marginBottom)}px`);
    main.style.setProperty('--visible-header-height', `${height + parseFloat(style.marginTop) + parseFloat(style.marginBottom)}px`);
  }

  onScrollUp() {
    const currentScroll = window.scrollY;
    const utilityBarHeight = document.querySelector('utility-bar')? document.querySelector('utility-bar').clientHeight : 0;
    const announcementBarHeight = document.querySelector('announcement-bar')? document.querySelector('announcement-bar').clientHeight : 0;

    const topScroll = utilityBarHeight + announcementBarHeight;
    if(currentScroll < this.lastScrollTop){ // scrolling up
      this.setAttribute('data-scroll', currentScroll > topScroll? 'true' : 'false');
    }else{ // scrolling down
      this.setAttribute('data-scroll', this.stickyType == 'scroll-up' || currentScroll < topScroll? 'false' : 'true');
    }

    this.getVisibleHeaderHeight();
    this.setAttribute('data-scroll-top', currentScroll > topScroll? 'false' : 'true');
    this.lastScrollTop = currentScroll <= 0? 0 : currentScroll;
  }

  getVisibleHeaderHeight() {
    const main = document.querySelector("main");
    if(!main) return;

    const height = this.offsetHeight;
    const style = getComputedStyle(this);
 
    if(this.dataset.sticky === 'none'){
      main.style.setProperty('--visible-header-height', '0px');
      return;
    }

    if(this.getAttribute('data-scroll') === 'true'){
      main.style.setProperty('--visible-header-height', `${height + parseFloat(style.marginTop) + parseFloat(style.marginBottom)}px`);
    }else{
      main.style.setProperty('--visible-header-height', '0px');
    }
  }

  ifScrollTop(){
    const currentScroll = window.scrollY;
    const utilityBarHeight = document.querySelector('utility-bar')? document.querySelector('utility-bar').clientHeight : 0;
    const announcementBarHeight = document.querySelector('announcement-bar')? document.querySelector('announcement-bar').clientHeight : 0;

    const topScroll = utilityBarHeight + announcementBarHeight;
    this.setAttribute('data-scroll-top', currentScroll > topScroll? 'false' : 'true');

    this.getVisibleHeaderHeight();
  }

  initMenu() {
    this.menu = this.querySelector(".menu-wrapper");

    // initialize megamenu
    this.megamenuWrapper = this.querySelector("#megamenu-wrapper");
    if (this.megamenuWrapper) {
      this.addEventListener("mouseleave", this.hideMegamenu.bind(this));

      this.querySelectorAll('[data-action="static-link"]').forEach(item => {
        item.addEventListener("mouseenter", this.hideMegamenuOnTimeOut.bind(this));
        item.addEventListener("focus", (e) => {
          item.classList.remove("no-keyboard-focus");
          item.addEventListener("blur", (e) => {
            item.classList.add("no-keyboard-focus");
          }, { once: true });
        });
      });

      this.querySelectorAll('[data-action="hover"]').forEach((item) => {
        item.addEventListener("mouseenter", (e) => {
          item.classList.add("no-keyboard-focus");
          const isKeyboard = false;
          this.displayMegamenu(e, isKeyboard);
        });
        item.addEventListener("mouseleave", this.hideMegamenu.bind(this));
        item.addEventListener("focus", (e) => {
          item.classList.remove("no-keyboard-focus");
          item.addEventListener("blur", (e) => {
            item.classList.add("no-keyboard-focus");
          }, { once: true });
        });
        item.addEventListener("keydown", (e) => {
          item.classList.remove("no-keyboard-focus");
          const isKeyboard = true;
          if (e.key === " " || e.code === "Space") {
            e.preventDefault();
            this.displayMegamenu(e, isKeyboard);
          } else if (e.key === "Escape") {
            this.hideMegamenu(e, isKeyboard);
          }
        });
      });

      this.querySelectorAll('[data-action="hover-dropdown"]').forEach(item => {
        item.addEventListener('mouseenter', this.closeMegamenu.bind(this));
        item.addEventListener('focus', (e) => {
          item.classList.remove("no-keyboard-focus");
          item.addEventListener("blur", (e) => {
            item.classList.add("no-keyboard-focus");
          }, { once: true });

          const currentTarget = e.currentTarget;
          const parent = currentTarget.closest('.group');

          if(!parent) return;
          parent.querySelectorAll('ul').forEach(ulItem => {
            ulItem.classList.add('focused');
          });

          item.addEventListener('blur', (e) => {
            parent.querySelectorAll('ul').forEach(ulItem => {
              ulItem.classList.remove('focused');
            });
          }, { once: true });

          item.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
              if (this.previouslyFocusedElement) {
                this.previouslyFocusedElement.focus();
              }
            }else if(e.key === " " || e.code === "Space"){
              e.preventDefault();
              parent.querySelectorAll('ul').forEach(ulItem => {
                ulItem.classList.remove('focused');
              }); 
            }
          });
        });
      });

      this.megamenuWrapper.addEventListener(
        "mouseenter",
        this.cancelHideMegamenu.bind(this)
      );
      this.megamenuWrapper.addEventListener(
        "mouseleave",
        this.hideMegamenu.bind(this)
      );

      this.megamenuWrapper.addEventListener("keydown", (e) => {
        if (e.key === " " || e.code === "Space") {
          e.preventDefault();
          this.cancelHideMegamenu();
        } else if (e.key === "Escape") {
          const isKeyboard = true;
          this.hideMegamenu(e, isKeyboard);
        }
      });
      this.megamenuWrapper.addEventListener(
        "blur",
        this.hideMegamenu.bind(this)
      );
    }

    // initialize dropdown menu
    this.dropdownMenus = this.querySelectorAll(
      '.menu--dropdown[data-tier="2"]'
    );
    if (this.dropdownMenus.length > 0) {
      this.dropdownMenus.forEach((dropdown) => {
        dropdown.querySelectorAll("a").forEach((item) => {
          item.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
              if (this.previouslyFocusedElement) {
                this.previouslyFocusedElement.focus();
              }
            } else if (e.key === "ArrowDown") {
              e.preventDefault();
              this.moveFocusInDropdown(1);
            } else if (e.key === "ArrowUp") {
              e.preventDefault();
              this.moveFocusInDropdown(-1);
            }
          });
        });
      });
    }
  }

  moveFocusInDropdown(direction) {
    const focusableElements = Array.from(
      document.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
    );

    const currentIndex = focusableElements.indexOf(document.activeElement);
    let nextIndex = currentIndex + direction;

    if (nextIndex >= focusableElements.length) nextIndex = 0; // Loop to the first element
    if (nextIndex < 0) nextIndex = focusableElements.length - 1; // Loop to the last element

    focusableElements[nextIndex]?.focus();
  }

  displayMegamenu(e, isKeyboard = false) {
    const currentTarget = e.currentTarget;
    const id = currentTarget.dataset.id;
    const selectedTemplate = this.querySelector(`#${id}`);

    this.megamenuWrapper.innerHTML = "";

    if (selectedTemplate) {
      this.previouslyFocusedElement = e.currentTarget;

      this.megamenuWrapper.innerHTML = selectedTemplate.innerHTML;
      this.megamenuWrapper.setAttribute("aria-hidden", "false");
      this.setAttribute("data-show-mega-menu", "true");

      const numCollectionList =
        this.megamenuWrapper.querySelectorAll(".menu--collection");
      let numCollectionListPerRow = 1;
      if (numCollectionList.length % 4 === 0) {
        numCollectionListPerRow = 4;
      } else if (numCollectionList.length % 3 === 0) {
        numCollectionListPerRow = 3;
      } else if (numCollectionList.length % 2 === 0) {
        numCollectionListPerRow = 2;
      } else if (numCollectionList.length > 4) {
        numCollectionListPerRow = 4;
      }
      this.megamenuWrapper.style.setProperty(
        "--num-media",
        numCollectionListPerRow
      );

     
      // check if current mega menu has hover split menu type
      if(this.megamenuWrapper.querySelector('[data-menu-type="hover-split"]')){
        const hoverSplitMenus = this.megamenuWrapper.querySelectorAll('.menu--megamenu-hover-split-child > li');
        hoverSplitMenus.forEach(item => {
          item.addEventListener('click', this.handleHoverSplitMegamenu.bind(this));
          item.addEventListener('keydown', (e) => {
            if(e.key === 'Enter' || e.key === ' '){
              e.preventDefault();
              this.handleHoverSplitMegamenu(e);
            }
          });
        });

        if(hoverSplitMenus.length > 0){
          setTimeout(() => {
            if(!isKeyboard){
              hoverSplitMenus[0].classList.add("no-keyboard-focus");
            }else{
              hoverSplitMenus[0].classList.remove("no-keyboard-focus");
              hoverSplitMenus[0].focus();
            }
       
            hoverSplitMenus.forEach(item => {
              const index = Array.from(hoverSplitMenus).indexOf(item);
              item.addEventListener("keydown", (e) => {
                item.classList.remove("no-keyboard-focus");
                if ((e.key === "Tab" && e.shiftKey) || e.key === "ArrowUp") {
                  if (index === 0) {
                    this.hideMegamenuByItem(true);
                  }
                } else if (e.key === "Tab" || e.key === "ArrowDown") {
                  if (index === hoverSplitMenus.length - 1) {
                    this.hideMegamenuByItem(true);
                  }
                }
              });
            });
          }, 1000);
        }
       
      }

      setTimeout(() => {
        const megamenuItems = this.megamenuWrapper.querySelectorAll("a");
        // add focus to the mega menu element
        if (megamenuItems.length > 0) {
          if (isKeyboard === false) {
            megamenuItems[0].classList.add("no-keyboard-focus");
          } else {
            megamenuItems[0].classList.remove("no-keyboard-focus");
            megamenuItems[0].focus();
          }
        }

        // add event listener to menu
        megamenuItems.forEach((item) => {
          const index = Array.from(megamenuItems).indexOf(item);
          item.addEventListener("keydown", (e) => {
            item.classList.remove("no-keyboard-focus");
            if ((e.key === "Tab" && e.shiftKey) || e.key === "ArrowUp") {
              if (index === 0) {
                this.hideMegamenuByItem(true);
              }
            } else if (e.key === "Tab" || e.key === "ArrowDown") {
              if (index === megamenuItems.length - 1) {
                this.hideMegamenuByItem(true);
              }
            }
          });
        });
      }, 1000);
    } else {
      console.warn(`Megamenu template with id "${id}" not found`);
    }

    clearTimeout(this.hideTimeout);
    this.hideTimeout = null;
  }

  handleHoverSplitMegamenu(e){
    const currentTarget = e.currentTarget;
    const linkHandle = currentTarget.dataset.linkHandle;

    // close all hover split menu items
    const hoverSplitMenus = this.megamenuWrapper.querySelectorAll('.menu--megamenu-hover-split-child > li');
    hoverSplitMenus.forEach(item => {
      if(item.dataset.linkHandle === linkHandle){
        item.setAttribute('data-active', 'true');
      }else{
        item.setAttribute('data-active', 'false');
      }
    });

    const grandChildMenus = this.megamenuWrapper.querySelectorAll('.menu--megamenu-hover-split-grandchild');
    grandChildMenus.forEach(item => {
      if(item.dataset.linkHandle === linkHandle){
        item.setAttribute('data-hidden', 'false');
        item.removeAttribute('inert');
      }else{
        item.setAttribute('data-hidden', 'true');
        item.setAttribute('inert', '');
      }
    });
  }

  hideMegamenu(e, isKeyboard = false) {
    if (!e.currentTarget) return;
    if(this.hideTimeout) return;

    this.hideTimeout = setTimeout(() => {
      this.closeMegamenu(isKeyboard);
    }, 300);
  }

  hideMegamenuOnTimeOut(){
    if(this.hideTimeout){
      clearTimeout(this.hideTimeout);
    }

    this.hideTimeout = setTimeout(() => {
      this.closeMegamenu();
    }, 500);
  }

  hideMegamenuByItem(isKeyboard = false) {
    this.closeMegamenu(isKeyboard);
  }

  closeMegamenu(isKeyboard = false){
    this.megamenuWrapper.innerHTML = "";
    this.megamenuWrapper.setAttribute("aria-hidden", "true");
    this.setAttribute("data-show-mega-menu", "false");

    if (this.previouslyFocusedElement) {
      if(isKeyboard !== false){
        this.previouslyFocusedElement.focus();
      }
    }

    clearTimeout(this.hideTimeout);
    this.hideTimeout = null;
  }

  cancelHideMegamenu() {
    if(this.hideTimeout){
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }
}

customElements.define("custom-header", CustomHeader);
